var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _taggedTemplateLiteral = require("/workspace/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pageResults = require('graph-results-pager');

var _require = require('graphql-request'),
    request = _require.request,
    gql = _require.gql;

var _require2 = require('./../constants'),
    graphAPIEndpoints = _require2.graphAPIEndpoints,
    chefAddress = _require2.chefAddress,
    TWENTY_FOUR_HOURS = _require2.TWENTY_FOUR_HOURS;

var _require3 = require('./../utils'),
    timestampToBlock = _require3.timestampToBlock,
    getAverageBlockTime = _require3.getAverageBlockTime;

var _require4 = require('./exchange'),
    exchangePairs = _require4.pairs;

var _require5 = require('./sushi'),
    sushiPriceUSD = _require5.priceUSD;

module.exports = {
  info: function info() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$block, block, _ref$timestamp, timestamp, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp;

              if (!block) {
                _context.next = 5;
                break;
              }

              _context.t0 = block;
              _context.next = 13;
              break;

            case 5:
              if (!timestamp) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return timestampToBlock(timestamp);

            case 8:
              _context.t1 = _context.sent;
              _context.next = 12;
              break;

            case 11:
              _context.t1 = undefined;

            case 12:
              _context.t0 = _context.t1;

            case 13:
              block = _context.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context.next = 17;
              return request(graphAPIEndpoints.masterchef, gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n                    masterChef(id: \"", "\", ", ") {\n                        ", "\n                    }\n                }"])), chefAddress, block, _info.properties.toString()));

            case 17:
              result = _context.sent;
              return _context.abrupt("return", _info.callback(result.masterChef));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  pool: function pool() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref2, _ref2$block, block, _ref2$timestamp, timestamp, _ref2$pool_id, pool_id, _ref2$pool_address, pool_address, result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref2$block = _ref2.block, block = _ref2$block === void 0 ? undefined : _ref2$block, _ref2$timestamp = _ref2.timestamp, timestamp = _ref2$timestamp === void 0 ? undefined : _ref2$timestamp, _ref2$pool_id = _ref2.pool_id, pool_id = _ref2$pool_id === void 0 ? undefined : _ref2$pool_id, _ref2$pool_address = _ref2.pool_address, pool_address = _ref2$pool_address === void 0 ? undefined : _ref2$pool_address;

              if (!(!pool_id && !pool_address)) {
                _context2.next = 3;
                break;
              }

              throw new Error("sushi-data: Pool ID / Address undefined");

            case 3:
              if (!block) {
                _context2.next = 7;
                break;
              }

              _context2.t0 = block;
              _context2.next = 15;
              break;

            case 7:
              if (!timestamp) {
                _context2.next = 13;
                break;
              }

              _context2.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context2.t1 = _context2.sent;
              _context2.next = 14;
              break;

            case 13:
              _context2.t1 = undefined;

            case 14:
              _context2.t0 = _context2.t1;

            case 15:
              block = _context2.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";

              if (!pool_id) {
                _context2.next = 23;
                break;
              }

              _context2.next = 20;
              return request(graphAPIEndpoints.masterchef, gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{\n                        pool(id: ", ", ", ") {\n                            ", "\n                        }\n                    }"])), pool_id, block, _pools.properties.toString()));

            case 20:
              result = _context2.sent;
              _context2.next = 26;
              break;

            case 23:
              _context2.next = 25;
              return request(graphAPIEndpoints.masterchef, gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["{\n                        pools(first: 1, where: {pair: \"", "\"}, ", ") {\n                            ", "\n                        }\n                    }"])), pool_address.toLowerCase(), block, _pools.properties.toString()));

            case 25:
              result = _context2.sent;

            case 26:
              return _context2.abrupt("return", _pools.callback(pool_id ? [result.pool] : result.pools)[0]);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  pools: function pools() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref3, _ref3$block, block, _ref3$timestamp, timestamp;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, _ref3$block = _ref3.block, block = _ref3$block === void 0 ? undefined : _ref3$block, _ref3$timestamp = _ref3.timestamp, timestamp = _ref3$timestamp === void 0 ? undefined : _ref3$timestamp;
              _context3.t0 = pageResults;
              _context3.t1 = graphAPIEndpoints.masterchef;

              if (!block) {
                _context3.next = 7;
                break;
              }

              _context3.t2 = {
                number: block
              };
              _context3.next = 16;
              break;

            case 7:
              if (!timestamp) {
                _context3.next = 14;
                break;
              }

              _context3.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context3.t4 = _context3.sent;
              _context3.t3 = {
                number: _context3.t4
              };
              _context3.next = 15;
              break;

            case 14:
              _context3.t3 = undefined;

            case 15:
              _context3.t2 = _context3.t3;

            case 16:
              _context3.t5 = _context3.t2;
              _context3.t6 = {
                block: _context3.t5
              };
              _context3.t7 = _pools.properties;
              _context3.t8 = {
                entity: 'pools',
                selection: _context3.t6,
                properties: _context3.t7
              };
              _context3.t9 = {
                api: _context3.t1,
                query: _context3.t8
              };
              return _context3.abrupt("return", (0, _context3.t0)(_context3.t9).then(function (results) {
                return _pools.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  stakedValue: function stakedValue() {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref4, _ref4$block, block, _ref4$timestamp, timestamp, _ref4$token_address, token_address, result;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {}, _ref4$block = _ref4.block, block = _ref4$block === void 0 ? undefined : _ref4$block, _ref4$timestamp = _ref4.timestamp, timestamp = _ref4$timestamp === void 0 ? undefined : _ref4$timestamp, _ref4$token_address = _ref4.token_address, token_address = _ref4$token_address === void 0 ? undefined : _ref4$token_address;

              if (token_address) {
                _context4.next = 3;
                break;
              }

              throw new Error("sushi-data: Token address undefined");

            case 3:
              if (!block) {
                _context4.next = 7;
                break;
              }

              _context4.t0 = block;
              _context4.next = 15;
              break;

            case 7:
              if (!timestamp) {
                _context4.next = 13;
                break;
              }

              _context4.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context4.t1 = _context4.sent;
              _context4.next = 14;
              break;

            case 13:
              _context4.t1 = undefined;

            case 14:
              _context4.t0 = _context4.t1;

            case 15:
              block = _context4.t0;
              block = block ? "block: { number: ".concat(block, " }") : "";
              _context4.next = 19;
              return request(graphAPIEndpoints.exchange, gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["{\n                    liquidityPosition(id: \"", "-", "\", ", ") {\n                        ", "\n                    }\n                }"])), token_address.toLowerCase(), chefAddress, block, _stakedValue.properties.toString()));

            case 19:
              result = _context4.sent;
              return _context4.abrupt("return", _stakedValue.callback(result.liquidityPosition));

            case 21:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  user: function user() {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _ref5, _ref5$block, block, _ref5$timestamp, timestamp, _ref5$user_address, user_address;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref5 = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {}, _ref5$block = _ref5.block, block = _ref5$block === void 0 ? undefined : _ref5$block, _ref5$timestamp = _ref5.timestamp, timestamp = _ref5$timestamp === void 0 ? undefined : _ref5$timestamp, _ref5$user_address = _ref5.user_address, user_address = _ref5$user_address === void 0 ? undefined : _ref5$user_address;

              if (user_address) {
                _context5.next = 3;
                break;
              }

              throw new Error("sushi-data: User address undefined");

            case 3:
              _context5.t0 = pageResults;
              _context5.t1 = graphAPIEndpoints.masterchef;
              _context5.t2 = {
                address: "\\\"".concat(user_address.toLowerCase(), "\\\"")
              };

              if (!block) {
                _context5.next = 10;
                break;
              }

              _context5.t3 = {
                number: block
              };
              _context5.next = 19;
              break;

            case 10:
              if (!timestamp) {
                _context5.next = 17;
                break;
              }

              _context5.next = 13;
              return timestampToBlock(timestamp);

            case 13:
              _context5.t5 = _context5.sent;
              _context5.t4 = {
                number: _context5.t5
              };
              _context5.next = 18;
              break;

            case 17:
              _context5.t4 = undefined;

            case 18:
              _context5.t3 = _context5.t4;

            case 19:
              _context5.t6 = _context5.t3;
              _context5.t7 = {
                where: _context5.t2,
                block: _context5.t6
              };
              _context5.t8 = _user.properties;
              _context5.t9 = {
                entity: 'users',
                selection: _context5.t7,
                properties: _context5.t8
              };
              _context5.t10 = {
                api: _context5.t1,
                query: _context5.t9
              };
              return _context5.abrupt("return", (0, _context5.t0)(_context5.t10).then(function (results) {
                return _user.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 25:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  users: function users() {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _ref6, _ref6$block, block, _ref6$timestamp, timestamp;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _ref6 = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {}, _ref6$block = _ref6.block, block = _ref6$block === void 0 ? undefined : _ref6$block, _ref6$timestamp = _ref6.timestamp, timestamp = _ref6$timestamp === void 0 ? undefined : _ref6$timestamp;
              _context6.t0 = pageResults;
              _context6.t1 = graphAPIEndpoints.masterchef;

              if (!block) {
                _context6.next = 7;
                break;
              }

              _context6.t2 = {
                number: block
              };
              _context6.next = 16;
              break;

            case 7:
              if (!timestamp) {
                _context6.next = 14;
                break;
              }

              _context6.next = 10;
              return timestampToBlock(timestamp);

            case 10:
              _context6.t4 = _context6.sent;
              _context6.t3 = {
                number: _context6.t4
              };
              _context6.next = 15;
              break;

            case 14:
              _context6.t3 = undefined;

            case 15:
              _context6.t2 = _context6.t3;

            case 16:
              _context6.t5 = _context6.t2;
              _context6.t6 = {
                block: _context6.t5
              };
              _context6.t7 = _user.properties;
              _context6.t8 = {
                entity: 'users',
                selection: _context6.t6,
                properties: _context6.t7
              };
              _context6.t9 = {
                api: _context6.t1,
                query: _context6.t8
              };
              return _context6.abrupt("return", (0, _context6.t0)(_context6.t9).then(function (results) {
                return _user.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 22:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  apys: function apys() {
    var _arguments7 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var _ref7, _ref7$block, block, _ref7$timestamp, timestamp, masterchefList, exchangeList, sushiUSD, totalAllocPoint, averageBlockTime;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _ref7 = _arguments7.length > 0 && _arguments7[0] !== undefined ? _arguments7[0] : {}, _ref7$block = _ref7.block, block = _ref7$block === void 0 ? undefined : _ref7$block, _ref7$timestamp = _ref7.timestamp, timestamp = _ref7$timestamp === void 0 ? undefined : _ref7$timestamp;
              _context7.next = 3;
              return module.exports.pools({
                block: block,
                timestamp: timestamp
              });

            case 3:
              masterchefList = _context7.sent;
              _context7.next = 6;
              return exchangePairs({
                block: block,
                timestamp: timestamp
              });

            case 6:
              exchangeList = _context7.sent;
              _context7.next = 9;
              return sushiPriceUSD({
                block: block,
                timestamp: timestamp
              });

            case 9:
              sushiUSD = _context7.sent;
              totalAllocPoint = masterchefList.reduce(function (a, b) {
                return a + b.allocPoint;
              }, 0);
              _context7.next = 13;
              return getAverageBlockTime({
                block: block,
                timestamp: timestamp
              });

            case 13:
              averageBlockTime = _context7.sent;
              return _context7.abrupt("return", masterchefList.map(function (masterchefPool) {
                var exchangePool = exchangeList.find(function (e) {
                  return e.id === masterchefPool.pair;
                });

                if (!exchangePool) {
                  return _objectSpread(_objectSpread({}, masterchefPool), {}, {
                    apy: 0
                  });
                }

                var tvl = masterchefPool.slpBalance * (exchangePool.reserveUSD / exchangePool.totalSupply);
                var sushiPerBlock = masterchefPool.allocPoint / totalAllocPoint * 100;
                var apy = sushiUSD * (sushiPerBlock * (60 / averageBlockTime) * 60 * 24 * 365) / tvl * 100;
                return _objectSpread(_objectSpread({}, masterchefPool), {}, {
                  apy: apy
                });
              }));

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  apys24h: function apys24h() {
    var _arguments8 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _ref8, _ref8$block, block, _ref8$timestamp, timestamp, timestampNow, results, results24ago;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref8 = _arguments8.length > 0 && _arguments8[0] !== undefined ? _arguments8[0] : {}, _ref8$block = _ref8.block, block = _ref8$block === void 0 ? undefined : _ref8$block, _ref8$timestamp = _ref8.timestamp, timestamp = _ref8$timestamp === void 0 ? undefined : _ref8$timestamp;

              if (!timestamp) {
                _context8.next = 5;
                break;
              }

              _context8.t0 = timestamp;
              _context8.next = 13;
              break;

            case 5:
              if (!block) {
                _context8.next = 11;
                break;
              }

              _context8.next = 8;
              return blockToTimestamp(block);

            case 8:
              _context8.t1 = _context8.sent;
              _context8.next = 12;
              break;

            case 11:
              _context8.t1 = Math.floor(Date.now() / 1000);

            case 12:
              _context8.t0 = _context8.t1;

            case 13:
              timestampNow = _context8.t0;
              timestamp24ago = timestampNow - TWENTY_FOUR_HOURS;
              timestamp48ago = timestamp24ago - TWENTY_FOUR_HOURS;

              if (!timestamp) {
                _context8.next = 22;
                break;
              }

              _context8.next = 19;
              return timestampToBlock(timestamp);

            case 19:
              _context8.t2 = _context8.sent;
              _context8.next = 23;
              break;

            case 22:
              _context8.t2 = block;

            case 23:
              block = _context8.t2;
              _context8.next = 26;
              return timestampToBlock(timestamp24ago);

            case 26:
              block24ago = _context8.sent;
              _context8.next = 29;
              return timestampToBlock(timestamp48ago);

            case 29:
              block48ago = _context8.sent;
              _context8.next = 32;
              return module.exports.apys({
                block: block
              });

            case 32:
              results = _context8.sent;
              _context8.next = 35;
              return module.exports.apys({
                block: block24ago
              });

            case 35:
              results24ago = _context8.sent;
              return _context8.abrupt("return", apys.callback24h(results, results24ago));

            case 37:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  }
};
var _info = {
  properties: ['bonusMultiplier', 'bonusEndBlock', 'devaddr', 'migrator', 'owner', 'startBlock', 'sushi', 'sushiPerBlock', 'totalAllocPoint', 'poolCount', 'slpBalance', 'slpAge', 'slpAgeRemoved', 'slpDeposited', 'slpWithdrawn', 'updatedAt'],
  callback: function callback(results) {
    return {
      bonusMultiplier: Number(results.bonusMultiplier),
      bonusEndBlock: Number(results.bonusEndBlock),
      devaddr: results.devaddr,
      migrator: results.migrator,
      owner: results.owner,
      startBlock: Number(results.startBlock),
      sushiPerBlock: results.sushiPerBlock / 1e18,
      totalAllocPoint: Number(results.totalAllocPoint),
      poolCount: Number(results.poolCount),
      slpBalance: Number(results.slpBalance),
      slpAge: Number(results.slpAge),
      slpAgeRemoved: Number(results.slpAgeRemoved),
      slpDeposited: Number(results.slpDeposited),
      slpWithdrawn: Number(results.slpWithdrawn),
      updatedAt: Number(results.updatedAt)
    };
  }
};
var _pools = {
  properties: ['id', 'pair', 'allocPoint', 'lastRewardBlock', 'accSushiPerShare', 'balance', 'userCount', 'slpBalance', 'slpAge', 'slpAgeRemoved', 'slpDeposited', 'slpWithdrawn', 'timestamp', 'block', 'updatedAt', 'entryUSD', 'exitUSD', 'sushiHarvested', 'sushiHarvestedUSD'],
  callback: function callback(results) {
    return results.map(function (_ref9) {
      var id = _ref9.id,
          pair = _ref9.pair,
          allocPoint = _ref9.allocPoint,
          lastRewardBlock = _ref9.lastRewardBlock,
          accSushiPerShare = _ref9.accSushiPerShare,
          balance = _ref9.balance,
          userCount = _ref9.userCount,
          slpBalance = _ref9.slpBalance,
          slpAge = _ref9.slpAge,
          slpAgeRemoved = _ref9.slpAgeRemoved,
          slpDeposited = _ref9.slpDeposited,
          slpWithdrawn = _ref9.slpWithdrawn,
          timestamp = _ref9.timestamp,
          block = _ref9.block,
          updatedAt = _ref9.updatedAt,
          entryUSD = _ref9.entryUSD,
          exitUSD = _ref9.exitUSD,
          sushiHarvested = _ref9.sushiHarvested,
          sushiHarvestedUSD = _ref9.sushiHarvestedUSD;
      return {
        id: Number(id),
        pair: pair,
        allocPoint: Number(allocPoint),
        lastRewardBlock: Number(lastRewardBlock),
        accSushiPerShare: BigInt(accSushiPerShare),
        userCount: Number(userCount),
        slpBalance: Number(slpBalance),
        slpAge: Number(slpAge),
        slpAgeRemoved: Number(slpAgeRemoved),
        slpDeposited: Number(slpDeposited),
        slpWithdrawn: Number(slpWithdrawn),
        addedTs: Number(timestamp),
        addedDate: new Date(timestamp * 1000),
        addedBlock: Number(block),
        lastUpdatedTs: Number(updatedAt),
        lastUpdatedDate: new Date(updatedAt * 1000),
        entryUSD: Number(entryUSD),
        exitUSD: Number(exitUSD),
        sushiHarvested: Number(sushiHarvested),
        sushiHarvestedUSD: Number(sushiHarvestedUSD)
      };
    });
  }
};
var _stakedValue = {
  properties: ['id', 'liquidityTokenBalance', 'pair { id, totalSupply, reserveETH, reserveUSD }'],
  callback: function callback(results) {
    return {
      id: results.id,
      liquidityTokenBalance: Number(results.liquidityTokenBalance),
      totalSupply: Number(results.pair.totalSupply),
      totalValueETH: Number(results.pair.reserveETH),
      totalValueUSD: Number(results.pair.reserveUSD)
    };
  }
};
var _user = {
  properties: ['id', 'address', 'pool { id, pair, balance, accSushiPerShare, lastRewardBlock }', 'amount', 'rewardDebt', 'entryUSD', 'exitUSD', 'sushiHarvested', 'sushiHarvestedUSD'],
  callback: function callback(results) {
    return results.map(function (entry) {
      return {
        id: entry.id,
        address: entry.address,
        poolId: Number(entry.id.split("-")[0]),
        pool: entry.pool ? {
          id: entry.pool.id,
          pair: entry.pool.pair,
          balance: Number(entry.pool.balance),
          accSushiPerShare: BigInt(entry.pool.accSushiPerShare),
          lastRewardBlock: Number(entry.pool.lastRewardBlock)
        } : undefined,
        amount: Number(entry.amount),
        rewardDebt: BigInt(entry.rewardDebt),
        entryUSD: Number(entry.entryUSD),
        exitUSD: Number(entry.exitUSD),
        sushiHarvested: Number(entry.sushiHarvested),
        sushiHarvestedUSD: Number(entry.sushiHarvestedUSD)
      };
    });
  }
};
var apys = {
  callback24h: function callback24h(results, results24h) {
    return results.map(function (result) {
      var result24h = results24h.find(function (e) {
        return e.id === result.id;
      }) || result;
      return _objectSpread(_objectSpread({}, result), {}, {
        slpBalanceChange: result.slpBalance / result24h.slpBalance * 100 - 100,
        slpBalanceChangeCount: result.slpBalance - result24h.slpBalance,
        userCountChange: result.userCount / result24h.userCount * 100 - 100,
        userCountChangeCount: result.userCount - result24h.userCount,
        sushiHarvestedChange: result.sushiHarvested / result24h.sushiHarvested * 100 - 100,
        sushiHarvestedChangeCount: result.sushiHarvested - result24h.sushiHarvested
      });
    });
  }
};